<template>
    <div
        class="list-slice__container"
    >
        <div>
            <button
                    v-for="n in pageCount"
                    class="list-slice__item list-slice__item_pointer"
                    :class="{'active': n === page}"
                    @click="changePage(n)"
            >
                {{n}}
            </button>
        </div>
        <table-settings
                :labels="labels"
                :rows="Object.keys(slices).length !== 0 ? slices : []"
                :isPreloader="isPreloader()"
                :columnSettings="columnSettings"
                :isEditable="false"
                :isActionButtons="true"
                @removeRow="onRemoveSlice"
        >

        </table-settings>

    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import serviceApi from "../../services/serviceApi";
import schemeApi from '../../schemes/schemeApi';
import serviceAuth from "../../services/serviceAuth";
import TableSettings from "../../components/Tables/TableSettings";
import schemeSettingsSlice from "../../schemes/schemeSettingsSlice";
let {
    routeSliceList,
    routeSliceRemove
} = schemeApi;
let {columnSettings, labels} = schemeSettingsSlice;
export default {
    name: 'ViewSettingsSlice',
    components: {
        TableSettings
    },
    /**
     * Данные компонента
     * @property {array} slices - список срезов
     * @property {boolean} isEmptySlices проверка ответа на пустоту
     * @property {boolean} isGettingList флаг получения списка клиентов
     * @property {boolean} isGettingUserList флаг получения списка пользователей
     * @property {boolean} isUpdatingList флаг внесения изменений в список
     * @property {boolean} canChange флаг разрешения на возможность редактировать
     * @property {Array} columnSettings - настройки столбцов
     * @property {Array} labels - заголовки столбцов
     * @property {Number} pageCount
     * @property {Number} page
     */
    data: () => ({
        isEmptySlices: false,

        isGettingList: false,
        isUpdatingList: false,
        canChange: false,

        slices: [],
        columnSettings: columnSettings,
        labels: labels,
        pageCount: 1,
        page: 1
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId
        }),
    },
    mounted() {
        // устанавливаем текущее название страницы
        this.setCurrentViewName("Срезы");
        // получаем право на редактирование
        this.canChange = serviceAuth.checkPermission(this.activeProjectId, 'make_slice');
        this.getData();
    },
    methods: {
        /**
         * проксируем мутации из стора
         * @property {Function} setCurrentViewName - установить текущее имя страницы
         */
        ...mapMutations([
            'setCurrentViewName'
        ]),
        /**
         * запрос на списка менеджеров
         * @async
         */
        async getData() {
            this.isGettingList = true;
            try {
                let {data = []} = await serviceApi.get(routeSliceList + "?page=" + (this.page - 1));
                let {slices = [], pageCount = 0} = data;
                this.pageCount = pageCount;
                this.slices = slices;
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
                else if (error.response.data.data.message === 'Доступ запрещен') {
                    alert('Доступ запрещен');
                    this.$router.push({name: 'analyticsSummary'});
                }
            }
            this.isGettingList = false;
        },
        isPreloader(){
            return this.isUpdatingList || this.isGettingList;
        },

        /**
         * запрос на удаление строки
         * @async
         */
        async onRemoveSlice(row){
            if(!confirm("Вы уверены что хотите удалить срез?")){
                return false;
            }
            try {
                await serviceApi.post(
                    routeSliceRemove,
                    {analytics_id: row.id}
                );
                this.getData();
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
        },
        /**
         * Изменение пагинации
         * @param page
         */
        changePage(page){
            if(page !== this.page){
                this.page = page;
                this.getData();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .list-slice__container {
        margin-top: 10px;
        padding: 20px 25px;
        background: #fff;
        border-radius: 14px;
        -webkit-box-flex: 1;
    }
    .list-slice__item{
        text-decoration: underline;
        border-radius: 10px;
        border: none;
        background: none;
        color: #2686e6;
        outline: none;
        padding: 10px;
    }
    .list-slice__item_pointer{
        cursor: pointer;
    }
    .list-slice__item_active{
        background: #dcdcdc;
    }
    .active{
        text-decoration: none;
    }
</style>